module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--7-6f60c73f54141ac7b436e33dca49b7de.jpg";